<template>
  <div>
    <vs-card class="mb-6">
      <div slot="header">
        <h2>Novo Evento</h2>
      </div>
      <!-- INICIO FORM DADOS ASSOCIADO E VEICULO  -->
      <form role="form" @submit.stop.prevent="buscarDadosAssociadoVeiculos">
        <h4 class="mb-3 mt-6">Dados do Beneficiário e do Veículo</h4>
        <hr class="mb-6" />
        <vs-row>
          <vs-col class="mb-2" vs-lg="2" vs-sm="6" vs-xs="12">
            <label>Placa/Chassi</label>
            <vs-switch class="mb-3" v-model="placa" style="width: 60px">
              <span slot="on">Placa</span>
              <span slot="off">Chassi</span>
            </vs-switch>
          </vs-col>
          <vs-col class="mb-2" vs-lg="3" vs-sm="6" vs-xs="12" v-if="placa">
            <vs-input
              key="placa"
              id="placa"
              name="Placa"
              label="Placa"
              v-model="form.placa"
              class="w-full"
              v-validate="{ required: true, min: 8 }"
              v-mask="'AAA-#XX#'"
              :state="validateState('Placa')"
              :class="validateClass('Placa')"
            />
          </vs-col>
          <vs-col class="mb-2" vs-lg="3" vs-sm="6" vs-xs="12" v-else>
            <vs-input
              key="Chassi"
              id="Chassi"
              name="Chassi"
              label="Chassi"
              v-model="form.chassi"
              class="w-full"
              v-validate="{ required: true, min: 17, max: 17 }"
              :state="validateState('Chassi')"
              :class="validateClass('Chassi')"
            />
          </vs-col>
          <vs-col class="mb-2" vs-lg="3" vs-sm="6" vs-xs="12">
            <vs-input
              class="w-full"
              label="CPF/CNPJ do Benefíciario"
              v-mask="maskCPFCNPJ"
              v-model="form.cpfcnpj"
              name="CPF/CNPJ do Benefíciario"
              id="CPF/CNPJ do Benefíciario"
              v-validate="{ required: true, min: tamanhoCPFCNPJ }"
              :state="validateState('CPF/CNPJ do Benefíciario')"
              :class="validateClass('CPF/CNPJ do Benefíciario')"
            />
          </vs-col>

          <vs-col
            class="mb-2"
            vs-lg="4"
            vs-sm="6"
            vs-xs="12"
            vs-type="flex"
            vs-justify="center"
            vs-align="flex-end"
          >
            <vs-button color="primary" type="filled" class="mt-2 mb-2"
              >Pesquisar Beneficiário</vs-button
            >
          </vs-col>
        </vs-row>

        <!-- ------------START ERROS----------------->
        <vs-alert
          v-if="errosDadosAssociado.length"
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
        >
          <ul>
            <li
              class="mb-2"
              v-for="error in errosDadosAssociado"
              :key="error.id"
            >
              {{ error }}
            </li>
          </ul>
        </vs-alert>
        <!-- ------------END ERROS----------------->

        <vs-row v-if="Object.keys(dadosAssociadoVeiculo).length !== 0">
          <vs-col class="mt-6 mb-3" vs-lg="6" vs-sm="6" vs-xs="12">
            <!-- INICIO TABELA DADOS ASSOCIADO -->
            <div class="flex justify-center">
              <h5>Dados do Beneficiário</h5>
            </div>
            <table class="table table-bordered">
              <tr>
                <th class="uppercase">Código</th>
                <td>{{ dadosAssociadoVeiculo.id_prospect }}</td>
              </tr>
              <tr>
                <th class="uppercase">Nome</th>
                <td>{{ dadosAssociadoVeiculo.nome }}</td>
              </tr>
              <tr>
                <th class="uppercase">Email</th>
                <td>{{ dadosAssociadoVeiculo.email }}</td>
              </tr>
              <tr>
                <th class="uppercase">Telefone</th>
                <td>{{ dadosAssociadoVeiculo.telefone }}</td>
              </tr>
              <tr>
                <th class="uppercase">Endereço</th>
                <td>{{ dadosAssociadoVeiculo.endereco }}</td>
              </tr>
              <tr>
                <th class="uppercase">Tipo</th>
                <td>{{ dadosAssociadoVeiculo.tipo }}</td>
              </tr>
              <tr>
                <th class="uppercase">{{ cpfcnpj }}</th>
                <td>{{ dadosAssociadoVeiculo.cpfcnpj }}</td>
              </tr>
              <tr>
                <th class="uppercase">Rg</th>
                <td>{{ dadosAssociadoVeiculo.rg_ie }}</td>
              </tr>
              <tr>
                <th class="uppercase">Cnh</th>
                <td>{{ dadosAssociadoVeiculo.cnh }}</td>
              </tr>
            </table>
            <!-- FIM TABELA DADOS ASSOCIADO -->
          </vs-col>

          <vs-col class="mt-6 mb-3" vs-lg="6" vs-sm="6" vs-xs="12">
            <!-- INICIO TABELA DADOS VEÍCULO -->
            <div class="flex justify-center"><h5>Dados do Veículo</h5></div>
            <table class="table table-bordered">
              <tr>
                <th class="uppercase">Marca</th>
                <td>{{ dadosAssociadoVeiculo.veiculomarca }}</td>
              </tr>
              <tr>
                <th class="uppercase">Modelo</th>
                <td>{{ dadosAssociadoVeiculo.veiculomodelo }}</td>
              </tr>
              <tr>
                <th class="uppercase">Ano</th>
                <td>{{ dadosAssociadoVeiculo.anomodelo }}</td>
              </tr>
              <tr>
                <th class="uppercase">Placa</th>
                <td>{{ dadosAssociadoVeiculo.placa }}</td>
              </tr>
              <tr>
                <th class="uppercase">Renavam</th>
                <td>{{ dadosAssociadoVeiculo.renavam }}</td>
              </tr>
              <tr>
                <th class="uppercase">Chassi</th>
                <td>{{ dadosAssociadoVeiculo.chassi }}</td>
              </tr>
              <tr>
                <th class="uppercase">Combustível</th>
                <td>{{ dadosAssociadoVeiculo.combustivel }}</td>
              </tr>
              <tr>
                <th class="uppercase">Código Fipe</th>
                <td>{{ dadosAssociadoVeiculo.codigofipe }}</td>
              </tr>
              <tr>
                <th class="uppercase">Cor</th>
                <td>{{ dadosAssociadoVeiculo.cor }}</td>
              </tr>
              <tr>
                <th class="uppercase">Estado Pneu</th>
                <td>{{ dadosAssociadoVeiculo.estadopneu }}</td>
              </tr>
              <tr>
                <th class="uppercase">Km</th>
                <td>{{ dadosAssociadoVeiculo.km }}</td>
              </tr>
              <tr>
                <th class="uppercase">Valor</th>
                <td>
                  {{ formatarValorParaReal(dadosAssociadoVeiculo.valorfipe) }}
                </td>
              </tr>
              <tr>
                <th class="uppercase">Valor Cobertura</th>
                <td>
                  {{
                    formatarValorParaReal(dadosAssociadoVeiculo.valorcobertura)
                  }}
                </td>
              </tr>
            </table>
            <!-- FIM TABELA DADOS VEÍCULO -->
          </vs-col>
        </vs-row>
      </form>
      <!-- FIM FORM DADOS ASSOCIADO E VEICULO  -->
    </vs-card>

    <vs-card class="mb-6" v-if="local">
      <!-- INICIO FORM DADOS DO EVENTO  -->
      <form role="form" @submit.stop.prevent="registerPreEvento">
        <h4 class="mb-3 mt-6">Dados do Evento</h4>
        <hr class="mb-6" />
        <vs-row>
          <vs-col class="mb-2" vs-lg="3" vs-sm="6" vs-xs="12">
            <label for="" class="vs-select--label">Tipo do Evento</label>
            <v-select
              :options="tiposEventos"
              v-model="form.tipoEvento"
              name="Tipo do Evento"
              id="Tipo do Evento"
              v-validate="{ required: true }"
              label="label"
              :state="validateState('Tipo do Evento')"
              :class="validateClass('Tipo do Evento')"
            >
            </v-select>
          </vs-col>
          <vs-col class="mb-2" vs-lg="3" vs-sm="6" vs-xs="12">
            <label for="" class="vs-select--label">Envolvimento</label>
            <v-select
              :options="envolvimento"
              v-model="form.envolvimento"
              name="Envolvimento"
              id="Envolvimento"
              v-validate="{ required: true }"
              label="label"
              :state="validateState('Envolvimento')"
              :class="validateClass('Envolvimento')"
            >
            </v-select>
          </vs-col>
          <vs-col class="mb-2" vs-lg="3" vs-sm="6" vs-xs="12">
            <label for="" class="vs-select--label">Data e Hora do Evento</label>
            <flat-pickr
              :config="configdateTimePicker"
              v-model="form.dataEvento"
              placeholder="DD/MM/YYYY HH:MM"
              class="w-full flat-Pickr"
              :class="flatPickrDataHoraEvento ? '' : 'flatpickr-danger'"
              name="Data e Hora do Evento"
              v-validate="{ required: true }"
              :state="validateState('Data e Hora do Evento')"
              :danger="validateClass('Data e Hora do Evento')"
            />
          </vs-col>
          <vs-col
            class="mb-2"
            vs-lg="3"
            vs-sm="6"
            vs-xs="12"
            vs-type="flex"
            vs-justify="center"
            vs-align="flex-end"
          >
            <vs-button color="primary" type="filled" class="mt-2 mb-2"
              >Registrar Pré Evento</vs-button
            >
          </vs-col>
        </vs-row>

        <!-- ------------START ERROS----------------->
        <vs-alert
          v-if="errosDadosEvento.length"
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
        >
          <ul>
            <li class="mb-2" v-for="error in errosDadosEvento" :key="error.id">
              {{ error }}
            </li>
          </ul>
        </vs-alert>
        <!-- ------------END ERROS----------------->
      </form>
      <!-- FIM FORM DADOS DO EVENTO  -->
    </vs-card>
  </div>
</template>
<script>
import locale from '../../locale';
import service from '../../services/index';
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import { decryptData } from '../../services/decryptData';

export default {
  components: {
    'v-select': vSelect,
    flatPickr,
  },
  data() {
    const envolvimento = ['Vítima', 'Causador'];
    const configdateTimePicker = {
      maxDate: 'today',
      enableTime: true,
      dateFormat: 'd/m/Y H:i',
      locale: Portuguese,
      time_24hr: true,
    };
    const form = {
      idEmpresa: null,
      placa: null,
      chassi: null,
      cpfcnpj: '',
      tipoEvento: null,
      envolvimento: null,
      dataEvento: null,
    };
    const flatPickrDataHoraEvento = true;
    const placa = true;
    const errosDadosAssociado = [];
    const errosDadosEvento = [];
    const dadosAssociadoVeiculo = {};
    const local = false;
    return {
      tiposEventos: [],
      envolvimento,
      configdateTimePicker,
      form,
      flatPickrDataHoraEvento,
      placa,
      errosDadosAssociado,
      errosDadosEvento,
      dadosAssociadoVeiculo,
      local,
    };
  },
  created() {
    this.$validator.localize('ptBr', locale);
    this.form.idEmpresa = localStorage.getItem('idEmpresa');
  },
  mounted() {
    this.buscaDadosSelects(
      'eventosMotivos',
      'tiposEventos',
      'nomeMotivo',
      'idMotivo',
    );
  },
  computed: {
    cpfcnpj() {
      return this.dadosAssociadoVeiculo.cpfcnpj.length === 14 ? 'cpf' : 'cnpj';
    },
    maskCPFCNPJ() {
      return this.form.cpfcnpj.length <= 14
        ? '###.###.###-##'
        : '##.###.###/####-##';
    },
    tamanhoCPFCNPJ() {
      return this.form.cpfcnpj.length <= 14 ? 14 : 18;
    },
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref) ? 'has-error' : '';
      }
      return null;
    },
    validateFields(fields) {
      return Promise.all(
        fields.map((field) => this.$validator.validate(field)),
      );
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      var url = `${model}/list/idEmpresa/${this.form.idEmpresa}`;
      if (model == 'eventosMotivos') url = `${model}/list`;
      service.getAll('g', {}, url).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
        console.log(this[array]);
      });
    },
    formatarValorParaReal(valor) {
      return valor.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },
    async buscarDadosAssociadoVeiculos() {
      await this.validateFields([
        'CPF/CNPJ do Benefíciario',
        this.placa ? 'Placa' : 'Chassi',
      ]);
      this.errosDadosAssociado = this.$validator.errors.all();

      if (this.errosDadosAssociado.length === 0) {
        this.$vs.loading();
        service
          .post('Eventos', 'buscar-dados-associados-veiculos', this.form)
          .then((res) => {
            this.verificaDadosAssociadoEVeiculo(res.data);
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.ocorreuUmErro();
          });
      }
    },
    verificaDadosAssociadoEVeiculo(dados) {
      if (dados.length === 0 || !dados[0].veiculos) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Não foi encontrado nenhum Beneficiário ou veiculo com os dados informados',
          color: 'danger',
        });
      } else {
        this.preencheDadosAssociadoVeiculo(dados[0]);
        this.local = true;
      }
    },
    preencheDadosAssociadoVeiculo(dados) {
      const veiculo = JSON.parse(dados.veiculos);
      this.dadosAssociadoVeiculo = { ...dados, ...veiculo[0] };
    },
    async registerPreEvento() {
      await this.validateFields([
        'Tipo do Evento',
        'Envolvimento',
        'Data e Hora do Evento',
      ]);
      this.validaFlatPickr();
      this.errosDadosEvento = this.$validator.errors.all();

      if (this.errosDadosEvento.length === 0) {
        const formulario = this.preparaFormularioPreEvento();
        this.$vs.loading();
        service
          .post('Eventos', 'InserirEvento', formulario)
          .then((res) => {
            const numeroDoEvento = res.data.idEvento;
            this.$vs.loading.close();
            this.$router.push(`/editar-evento/${numeroDoEvento}`);
          })
          .catch(() => {
            this.ocorreuUmErro();
            this.$vs.loading.close();
          });
      }
    },
    validaFlatPickr() {
      this.flatPickrDataHoraEvento = this.form.dataEvento ? true : false;
    },
    preparaFormularioPreEvento() {
      const dataInvertida = this.form.dataEvento
        .slice(0, 10)
        .split('/')
        .reverse()
        .join('-');
      const hora = this.form.dataEvento.slice(11, this.form.dataEvento.length);
      const agora = new Date(`${dataInvertida} ${hora}`);
      const dataISO = agora.toISOString();
      const dataFormatada = dataISO.slice(0, 19) + '.000Z';

      return {
        idVeiculo: this.dadosAssociadoVeiculo.id_veiculo,
        tipoEvento: {
          id: this.form.tipoEvento.id,
          valor: this.form.tipoEvento.label,
        },
        dataEvento: dataFormatada,
        envolvimento: this.form.envolvimento,
        idTipoEvento: this.form.tipoEvento.id,
        from: 'ADM',
      };
    },
    ocorreuUmErro() {
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: 'Ocorreu um erro, por favor tente novamente!',
        color: 'danger',
      });
    },
  },
};
</script>
<style scoped lang="scss">
.flatpickr-danger {
  border: 1px solid red !important;
}

.flat-Pickr {
  padding: 0.7rem;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: #626262;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
